import { Capacitor } from "@capacitor/core";
import { Geolocation } from "@capacitor/geolocation";

// El WebView de Capacitor implementa su propio navigator.geolocation, que no
// siempre refleja el permiso nativo de Android ya concedido (por eso la app
// pedía/"no activaba" la ubicación aunque el usuario ya la hubiera permitido).
// Esto reemplaza getCurrentPosition/watchPosition/clearWatch por el plugin
// nativo de Capacitor cuando corre como app — el resto del código (páginas,
// modales, formularios) no necesita cambiar: Capacitor devuelve el mismo shape
// { coords: { latitude, longitude, ... }, timestamp } que la API del navegador.
export function installNativeGeolocationShim() {
  if (!Capacitor.isNativePlatform()) return;
  if (!navigator.geolocation) return;

  const watchCallbackIds = new Map();
  let nextWatchId = 1;

  navigator.geolocation.getCurrentPosition = (success, error, options) => {
    Geolocation.getCurrentPosition(options).then(success).catch((err) => {
      if (error) error(err);
    });
  };

  navigator.geolocation.watchPosition = (success, error, options) => {
    const id = nextWatchId++;
    Geolocation.watchPosition(options || {}, (pos, err) => {
      if (err) { if (error) error(err); return; }
      if (pos) success(pos);
    }).then((callbackId) => watchCallbackIds.set(id, callbackId));
    return id;
  };

  navigator.geolocation.clearWatch = (id) => {
    const callbackId = watchCallbackIds.get(id);
    if (callbackId) Geolocation.clearWatch({ id: callbackId });
    watchCallbackIds.delete(id);
  };
}
